import React, { memo, useState, useMemo, useCallback, useEffect, useRef } from 'react';
import { SortBy } from "tea-component/table/addons";
import GPSelectMultiple from '@gp/components/SelectMultiple';
import Overview from './components/Overview';
import FiveYearHeadcounts from './components/FiveYearHeadcounts';
import BreakdownList from './components/BreakdownList';
// import { context as Context } from "@gp/components/Context";
import {
  fetchStudioOverallOverviewPageData,
  fetchStudioOverallPeopleFiveYearHeadcountsData,
} from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { getArraySort } from '@gp/utils/common';
import { useRequest } from 'ahooks';
import './index.scss';

const People: React.FC<IStudioOverallPeopleProps> = () => {
  const [selectBO, setSelectBO] = useState<string[]>([]);
  const [lastSelectBO, setLastSelectBO] = useState<string[]>([]);
  // const [fiveYearLoading, setFiveYearLoading] = useState<boolean>(false);
  // const [fiveYearResList, setFiveYearResList] = useState<any>(null);
  // const [fiveYearUpdateTime, setFiveYearUpdateTime] = useState<string>('');
  const sortParamsRef = useRef<SortBy>({
    by: '',
    order: undefined,
  });

  // bo筛选器数据
  const { loading: filterBOLoading, data: filterBOList } = useRequest(
    fetchStudioOverallOverviewPageData,
    { defaultParams: [{ page: 'people' }] },
  );

  const {
    data: fiveYearData,
    loading: fiveYearLoading,
    run: fiveYearRun,
  } = useRequest(fetchStudioOverallPeopleFiveYearHeadcountsData, {
    manual: true,
  });

  const handleBOFilterChange = useCallback(
    (v: string[]) => {
      // 重复全选的效果不请求接口
      if (
        v?.length === filterBOList?.management_team?.length &&
        !lastSelectBO?.length
      )
        return;
      // 当length是全选时，也设置成[]
      if (v?.length === filterBOList?.management_team?.length) {
        setSelectBO([]);
        setLastSelectBO([]);
        return;
      }

      const newSelectBO = v ? [...v] : [];
      setSelectBO(newSelectBO);
      setLastSelectBO(newSelectBO);
    },
    [filterBOList?.management_team?.length, lastSelectBO],
  );

  const boOptions = useMemo(() => {
    const options = [];
    const boList = filterBOList?.management_team;
    if (Array.isArray(boList) && boList?.length) {
      // 先排序
      let isIncludeOthersItem = false;
      const filterOthersBOlist = boList?.filter((t: string) => {
        if (t?.toLowerCase() === 'others') {
          isIncludeOthersItem = true;
        }
        return t?.toLowerCase() !== 'others';
      });
      const tempSortBOList = getArraySort(filterOthersBOlist, 'string', 'asc');
      const sortBOList = isIncludeOthersItem
        ? [...tempSortBOList, 'Others']
        : tempSortBOList;
      for (let i = 0; i < sortBOList?.length; i++) {
        const t = sortBOList?.[i];
        options.push({
          text: t,
          value: t,
          groupKey: 'separated',
        });
      }
    }

    return options;
  }, [filterBOLoading]);

  useEffect(() => {
    fiveYearRun({
      // 'start_date': '',
      // 'end_date': '',
      'management_team': selectBO,
      'order_metric': sortParamsRef?.current?.by,
      'order': sortParamsRef?.current?.order,
    });
  }, [selectBO]);

  return (
    <main className="dbg-studio-overall-people">
      <GPSelectMultiple
        className="dbg-studio-overall-people-selector"
        label="Business Owner"
        searchable
        disabled={filterBOLoading}
        options={boOptions}
        value={selectBO}
        onChange={handleBOFilterChange}
      />
      <Overview
        filterBOLoading={filterBOLoading}
        selectBO={selectBO}
        // setFiveYearLoading={setFiveYearLoading}
        // setFiveYearResList={setFiveYearResList}
        // setFiveYearUpdateTime={setFiveYearUpdateTime}
      />
      <FiveYearHeadcounts
        loading={filterBOLoading || fiveYearLoading}
        data={fiveYearData?.headcounts_y5}
        selectBO={selectBO}
        updateTime={fiveYearData?.update_time_y5}
        sortParamsRef={sortParamsRef}
        run={fiveYearRun}
      />
      <BreakdownList filterBOLoading={filterBOLoading} selectBO={selectBO} />
    </main>
  );
};

export default memo(People);
